import { pct } from '@shared/format';
import { HEARD_VISIBLE } from '@shared/game/heat';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Bomb, Bulb, Gem } from './Icons';
import { rich } from './rich';

export function History() {
  const game = useController().game.value;
  if (!game?.turns.length)
    return (
      <div class="hist">
        {game?.status === 'play' && (
          <div class="tip">
            <Bulb />
            <span>{rich(t.emptyTip)}</span>
          </div>
        )}
      </div>
    );
  return (
    <div class="hist" data-testid="history">
      {game.turns
        .slice()
        .reverse()
        .map((turn) => {
          const word = game.words[turn.pick] ?? '';
          const aimed = turn.aimed != null ? game.words[turn.aimed] : null;
          const heard = turn.role !== 'b' && turn.heard >= HEARD_VISIBLE;
          return (
            <div class={`hrow ${turn.role}`} data-testid="history-row" key={`${turn.clue}-${turn.pick}`}>
              <span class="ic" aria-hidden="true">
                {turn.role === 't' ? <Gem /> : turn.role === 'b' ? <Bomb /> : '✕'}
              </span>
              <span class="body">
                <span class="c">«{turn.clue}»</span>
                <span class="r">
                  {turn.role === 't' && (
                    <>
                      <span class="good">→ {word} ✓</span>
                      {heard && (
                        <>
                          <br />
                          <small class="heard">{t.heardNote}</small>
                        </>
                      )}
                    </>
                  )}
                  {turn.role === 'd' && (
                    <>
                      <span class="bad">
                        → {word} — {t.decoyMark}
                      </span>
                      {aimed && (
                        <>
                          <br />
                          <small>почти выбрал «{aimed}»</small>
                        </>
                      )}
                      {heard && (
                        <>
                          <br />
                          <small class="heard">
                            {t.heardNote}: +{pct(turn.heard)}
                          </small>
                        </>
                      )}
                    </>
                  )}
                  {turn.role === 'b' && <span style={{ color: 'var(--bomb)' }}>→ {word} 💥</span>}
                </span>
              </span>
              {turn.role !== 'b' && turn.add >= HEARD_VISIBLE && (
                <span class="h">
                  <Bomb />+{pct(turn.add)}
                </span>
              )}
            </div>
          );
        })}
    </div>
  );
}
